import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { ROUTES } from './change-password.routes';

import { ChangePasswordFormComponent } from './change-password-form.component';
import { SharedModule } from '../shared';
import { ChangePasswordService } from './change-password.service';

const components = [
  ChangePasswordFormComponent,
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    RouterModule.forChild(ROUTES),
    RouterModule,
  ],
  declarations: [...components],
  exports: [...components],
  providers: [
    ChangePasswordService
  ]
})
export class ChangePasswordModule { }
